module.exports = __webpack_public_path__ + "img/walk.jpg";